import { Form } from 'formik';
import { FormControl, Button } from 'react-bootstrap';
import styled from 'styled-components';
// import { absoluteUrl } from '@lib/helpers';

// export const FormStyled = styled(Form)`
//   background: url(${absoluteUrl(
//         '/assets/quotation/woman_on_mobile_rev3@2x.jpg'
//       )})
//       center top no-repeat,
//     url(${absoluteUrl('/assets/quotation/bg_mobile@2x.png')}) center
//       bottom no-repeat;
//   background-size: 100%, cover;
//   padding: 16px;

//   @media (min-width: 768px) {
//     background-size: cover;
//   }

//   @media (min-width: 992px) {
//     background: url(${absoluteUrl(
//         '/assets/quotation/woman_on_mobile_rev3@2x.png'
//       )})
//       center top no-repeat;
//     background-size: 100%;
//     padding: 40px;
//     height: 550px;
//   }
// `;

export const Wrapper = styled.div`
  background-color: #fff;
`;

export const FormStyled = styled(Form)`
  background-color: #fff;
  // @media (min-width: 992px) {
  //   padding: 40px;
  // }
`;

export const Header = styled.h1`
  margin: 0 0 32px;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.38;
  text-align: left;
  color: #ffffff;

  @media (min-width: 768px) {
    font-size: 24px;
  }

  @media (min-width: 992px) {
    font-size: 30px;
  }

  @media (min-width: 1200px) {
    font-size: 40px;
  }
`;

export const FormControlStyled = styled(FormControl)`
  height: 40px;
`;

export const ButtonContainer = styled.div`
  display: flex !important;
  flex-direction: row;
  align-items: flex-start;
  align-content: flex-start;

  .btn {
    width: 120px;
    font-weight: bold;
  }
`;

export const Subtitle = styled.div`
  display: block;
  color: #9d9999;
  font-weight: bold;
  text-transform: uppercase;
  margin: 18px 0 12px;
  position: relative;
  @media (min-width: 767px) {
    &::after {
      content: '';
      border-top: 1px dashed #9d9999;
      width: 69%;
      display: block;
      position: absolute;
      bottom: 10px;
      right: 15px;
    }
  }
`;

export const HelperTitle = styled.div`
  display: block;
  color: #9d9999;
  margin-bottom: 12px;
`;

export const HelperUploadText = styled.span`
  display: block;
  //color: #347fc3;
  font-weight: bold;
`;

export const ButtonUpload = styled.label`
  width: 200px;
  max-width: 100%;
`;

export const PreviewWrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -3px;
  padding: 0;
  list-style: none;

  li {
    width: 20%;
    padding: 3px;
    align-items: center;
    justify-content: center;
    position: relative;
    .icon-close {
      position: absolute;
      top: 0;
      right: 0;
      width: 14px;
      height: 14px;
      z-index: 1;
      opacity: 1;
      background-color: transparent;
      &:before,
      &:after {
        left: 4px;
        content: ' ';
        height: 14px;
        width: 2px;
        background-color: var(--danger);
      }
    }
    img {
      border-radius: 4px;
      border: 1px solid #5dadf1;
      width: 50px;
      height: 50px;
      object-fit: center;
    }
  }
`;

export const ErrorText = styled.div`
  font-size: 0.875em;
  color: #dc3545;
  margin-top: 6px;
  padding-left: 3px;
`;

export const SubmitButton = styled(Button)`
  width: 200px;
  max-width: 100%;
`;
